import { render, staticRenderFns } from "./RealNameAuthQrDialog.vue?vue&type=template&id=1ca9a929"
import script from "./RealNameAuthQrDialog.vue?vue&type=script&lang=js"
export * from "./RealNameAuthQrDialog.vue?vue&type=script&lang=js"
import style0 from "./RealNameAuthQrDialog.vue?vue&type=style&index=0&id=1ca9a929&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports